/* This example requires Tailwind CSS v2.0+ */
const categories = [
  {
    name: '中西區',
    href: '/ProductList',
    imageSrc: '/images/category/1.jpg',
  },
  {
    name: '東區',
    href: '/ProductList',
    imageSrc: '/images/category/2.jpg',
  },
  {
    name: '南區',
    href: '/ProductList',
    imageSrc: '/images/category/3.jpg',
  },
  {
    name: '灣仔區',
    href: '/ProductList',
    imageSrc: '/images/category/4.jpg',
  },
  {
    name: '九龍城區',
    href: '/ProductList',
    imageSrc: '/images/category/5.jpg'
  },
  {
    name: '觀塘區',
    href: '/ProductList',
    imageSrc: '/images/category/6.jpg'
  },
  {
    name: '深水埗區',
    href: '/ProductList',
    imageSrc: '/images/category/7.jpg'
  },
  {
    name: '黃大仙區',
    href: '/ProductList',
    imageSrc: '/images/category/8.jpg'
  },
  {
    name: '油尖旺區',
    href: '/ProductList',
    imageSrc: '/images/category/9.jpg'
  },
  {
    name: '離島區',
    href: '/ProductList',
    imageSrc: '/images/category/10.jpg'
  },
  {
    name: '葵青區',
    href: '/ProductList',
    imageSrc: '/images/category/11.jpg'
  }, {
    name: '北區',
    href: '/ProductList',
    imageSrc: '/images/category/12.jpg'
  },
  {
    name: '西貢區',
    href: '/ProductList',
    imageSrc: '/images/category/13.jpg'
  },
  {
    name: '沙田區',
    href: '/ProductList',
    imageSrc: '/images/category/14.jpg'
  },
  {
    name: '大埔區',
    href: '/ProductList',
    imageSrc: '/images/category/15.jpg'
  },
  {
    name: '荃灣區',
    href: '/ProductList',
    imageSrc: '/images/category/16.jpg'
  },
  {
    name: '屯門區',
    href: '/ProductList',
    imageSrc: '/images/category/17.jpg'
  },
  {
    name: '元朗區',
    href: '/ProductList',
    imageSrc: '/images/category/18.jpg'
  },

]

const categories2 = [
  {
    refType: '公屋/居屋',
    name: 'Y2型',
    href: '/ProductList?style=Y2',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋/居屋',
    name: 'Y3型',
    href: '/ProductList?style=Y3',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋/居屋',
    name: 'Y4型',
    href: '/ProductList?style=Y4',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '居屋',
    name: '新十字型',
    href: '/ProductList?style=NCB',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '居屋',
    name: '康和式',
    href: '/ProductList?style=CB',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '居屋',
    name: '和諧式',
    href: '/ProductList?style=HR',
    imageSrc: '/images/category2/mp.jpg',
  },
]

const categories2_1 = [
  {
    refType: '公屋',
    name: '相連長型',
    href: '/ProductList?style=LB',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋',
    name: '長型或新長型',
    href: '/ProductList?style=OS',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋',
    name: '單或雙工字型',
    href: '/ProductList?style=SORDHB',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋',
    name: '雙塔式',
    href: '/ProductList?style=TT',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: '公屋',
    name: '非標準型',
    href: '/ProductList?style=NSBD',
    imageSrc: '/images/category2/mp.jpg',
  },
  {
    refType: ' ',
    name: '其他',
    href: '/ProductList?style=Others',
    imageSrc: '/images/category2/mp.jpg',
  },
]

export default function MainCategory() {
  return (
    <>
      {/* According to decoration style */}
      <div className="bg-white lg:mt-16 mt-4">
        <div className="xl:max-w-7xl xl:mx-auto xl:px-8">
          <div className="px-4 sm:px-6 sm:flex sm:items-center sm:justify-between lg:px-8 xl:px-0">
            <h2 className="lg:text-xl font-extrabold tracking-tight text-gray-900 sm:text-lg">根據房屋類型查看裝修案例</h2>
            <a href='/ProductList' className="hidden text-sm font-semibold text-cyan-900 hover:text-cyan-600 sm:block">
              查看全部案例<span aria-hidden="true"> &rarr;</span>
            </a>
          </div>

          <div className="relative">
            <div className="relative w-full pb-6 -mb-8 overflow-x-auto lg:mt-8 mt-4">
              <ul
                className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-6 lg:gap-x-8"
              >
                {categories2.map((category, index) => (
                  <a
                    key={index}
                    href={category.href}
                    className=" lg:mb-4 relative lg:w-40 w-28 lg:h-40 h-28 rounded-lg p-6 flex flex-col overflow-hidden hover:opacity-75 xl:w-auto"
                  >
                    <span aria-hidden="true" className="absolute inset-0">
                      <img src={category.imageSrc} alt="" className="w-full h-full object-center object-cover" />
                    </span>
                    <span
                      aria-hidden="true"
                      className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-gray-800 opacity-50"
                    />

                    <span className="relative mt-auto lg:text-xl font-bold text-white sm:text-lg text-center">{category.refType}</span>
                    <span className="relative  lg:text-xl font-bold text-white sm:text-lg text-center">{category.name}</span>

                  </a>
                ))}
              </ul>
            </div>

            <div className="relative w-full pb-6 -mb-6 overflow-x-auto lg:mt-8 mt-10">
              <ul
                className="mx-4 inline-flex space-x-8 sm:mx-6 lg:mx-0 lg:space-x-0 lg:grid lg:grid-cols-6 lg:gap-x-8"
              >
                {categories2_1.map((category, index) => (
                  <a
                    key={index}
                    href={category.href}
                    className=" lg:mb-4 relative lg:w-40 w-28 lg:h-40 h-28 rounded-lg p-6 flex flex-col overflow-hidden hover:opacity-75 xl:w-auto"
                  >
                    <span aria-hidden="true" className="absolute inset-0">
                      <img src={category.imageSrc} alt="" className="w-full h-full object-center object-cover" />
                    </span>
                    <span
                      aria-hidden="true"
                      className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-gray-800 opacity-50"
                    />
                    <span className="relative mt-auto lg:text-xl font-bold text-white sm:text-lg text-center">{category.refType}</span>
                    <span className="relative  lg:text-xl font-bold text-white sm:text-lg text-center">{category.name}</span>
                  </a>
                ))}
              </ul>
            </div>
          </div>
          <div className="mt-6 px-4 sm:hidden">
            <a href='/ProductList' className="block text-sm font-semibold text-cyan-900 hover:text-cyan-600">
              查看全部案例<span aria-hidden="true"> &rarr;</span>
            </a>
          </div>
        </div>
      </div >
      {/* End of decoration style */}
    </>
  )
}
